// import request from '../shared/lib/request';
import constants from '../shared/constants';
import requestWrapper from '../shared/lib/requestWrapper';

async function create(payload) {
    var response = await requestWrapper({
        url:    '/Appointment',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function update(payload) {
    var response = await requestWrapper({
        url:    '/Appointment/' + payload.data.id,
        method: 'PUT',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function complete(payload) {
    var response = await requestWrapper({
        url:    '/Appointment/' + payload.data.idAppointment + '/complete',
        method: 'PUT',
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function get(payload) {
    var response = await requestWrapper({
        url:    '/Appointment/' + payload.data.idAppointment,
        method: 'GET',
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function search(payload) {
    var response = await requestWrapper({
        url:    '/Appointment/search',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

const AppointmentService = {
    create, update, get, complete, search
}

export default AppointmentService;